// @mui material components
import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Checkbox,
  Divider,
  Tooltip,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

import { useAuthUser } from "react-auth-kit";
import AppConfig from "appConfig";
import MessageDialog from "app/components/message_dialog";

function Agents() {
  const pageTitle = "Agents";
  usePageTitle(pageTitle);

  const auth = useAuthUser();
  const accountInfo = auth();

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [openNewCheckDialog, setOpenNewCheckDialog] = useState(false);
  const [openEditCheckDialog, setOpenEditCheckDialog] = useState(false);

  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [agents, setAgents] = useState([]);
  const [lastName, setLastName] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const [staffNumber, setStaffNumber] = useState(null);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [openMoreActionsDialog, setOpenMoreActionsDialog] = useState(false);

  const [openUploadAgentsDialog, setOpenUploadAgentsDialog] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);

  const [showMessageComponentDialog, setShowMessageComponentDialog] = useState(false);
  const [messageDestinationType, setMessageDestinationType] = useState("account.agents");
  const [messageDestinationKey, setMessageDestinationKey] = useState(accountInfo.account.reference);
  const [messageDestinationDescription, setMessageDestinationDescription] = useState(null);

  const [agentGroups, setAgentGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [openAssignGroupDialog, setOpenAssignGroupDialog] = useState(false);

  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [openAssignCampaignDialog, setOpenAssignCampaignDialog] = useState(false);

  const selectionMax = 100;

  async function updateStatus(reference) {
    setShowLoading(true);

    await axios
      .get(`portal/agents/${reference}/status/update.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteAgent(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/agents/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editAgent() {
    if (lastName === null) {
      setSeverity("error");
      setErrMsg("Last name is required.");
      setOpen(true);
      return;
    }

    if (firstName === null) {
      setSeverity("error");
      setErrMsg("First name is required.");
      setOpen(true);
      return;
    }

    if (emailAddress === null) {
      setSeverity("error");
      setErrMsg("Email address is required.");
      setOpen(true);
      return;
    }

    if (phoneNumber === null) {
      setSeverity("error");
      setErrMsg("Phone number is required.");
      setOpen(true);
      return;
    }

    setOpenEditCheckDialog(false);
    setShowLoading(true);

    const json = {
      last_name: `${lastName}`,
      first_name: `${firstName}`,
      email_address: `${emailAddress}`,
      phone_number: `${phoneNumber}`,
      staff_number: `${staffNumber}`,
    };

    await axios
      .post(`/portal/agents/${selectedAgent.reference}/edit.json`, json)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  function addAgentChecked(reference) {
    const myArray = selectedAgents;
    const index = myArray.indexOf(reference);
    if (index > 0) {
      return true;
    }

    if (myArray.length >= selectionMax) {
      setSeverity("error");
      setErrMsg(`A maximum of ${selectionMax} agents can be selected at a time.`);
      setOpen(true);
      return false;
    }
    myArray.push(reference);
    setSelectedAgents(myArray);
    // console.log(myArray.length);
    return true;
  }

  function removeAgentChecked(reference) {
    const myArray = selectedAgents;
    const index = myArray.indexOf(reference);
    myArray.splice(index, 1);

    // console.log(myArray);
    setSelectedAgents(myArray);
  }

  const tableColumns = [
    { Header: "#", accessor: "id", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    // { Header: "Last Name", accessor: "last_name", align: "left" },
    // { Header: "First Name", accessor: "first_name", align: "left" },
    { Header: "Staff Number", accessor: "staff_number", align: "left" },
    { Header: "Email", accessor: "email_address", align: "left" },
    { Header: "Phone", accessor: "phone_number", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
    { Header: "Added On", accessor: "created", align: "right" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((accountAgent) => {
      rows.push({
        id: (
          <Checkbox
            // checked={selectedAgents.includes(accountAgent.reference)}
            onClick={(e) => {
              if (e.target.checked) {
                const checked = addAgentChecked(accountAgent.reference);
                e.target.checked = checked;
                if (!checked) {
                  e.preventDefault();
                }
              } else {
                removeAgentChecked(accountAgent.reference);
              }
            }}
          />
        ),
        // id: <b>{count}</b>,
        // currency: <b>{echeck.currency.currency_code}</b>,
        staff_number: accountAgent.staff_number,
        name: `${accountAgent.agent.last_name} ${accountAgent.agent.first_name}`,
        // last_name: accountAgent.agent.last_name,
        // first_name: accountAgent.agent.first_name,
        email_address: accountAgent.agent.email_address,
        phone_number: accountAgent.agent.phone_number,
        status: (
          <MDBox>
            <Icon color={accountAgent.status ? "success" : "error"}>
              {accountAgent.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <Tooltip title="View Agent">
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                onClick={() => {
                  navigate(`/agents/${accountAgent.reference}`);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>visibility</Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Send Message">
              <MDButton
                size="small"
                variant="outlined"
                color="dark"
                iconOnly
                onClick={() => {
                  setMessageDestinationType("account.agent");
                  setMessageDestinationKey(accountAgent.reference);
                  setMessageDestinationDescription(
                    `Send message to ${accountAgent.agent.last_name} ${accountAgent.agent.first_name}`
                  );
                  setShowMessageComponentDialog(true);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>mail</Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title={accountAgent.status ? "Disable" : "Enable"}>
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                onClick={() => {
                  if (
                    window.confirm(
                      `${accountAgent.status ? "Disable" : "Enable"} ${
                        accountAgent.agent.first_name
                      }?`
                    ) === true
                  ) {
                    updateStatus(accountAgent.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  {accountAgent.status ? "pause" : "play_arrow"}
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Edit">
              <MDButton
                size="small"
                variant="outlined"
                color="warning"
                iconOnly
                onClick={() => {
                  if (window.confirm(`Edit ${accountAgent.agent.first_name}?`) === true) {
                    setSelectedAgent(accountAgent);

                    setLastName(accountAgent.agent.last_name);
                    setFirstName(accountAgent.agent.first_name);
                    setEmailAddress(accountAgent.agent.email_address);
                    setPhoneNumber(accountAgent.agent.phone_number);
                    setStaffNumber(accountAgent.staff_number);

                    setOpenEditCheckDialog(true);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  edit
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Delete">
              <MDButton
                size="small"
                variant="outlined"
                color="error"
                iconOnly
                onClick={() => {
                  if (window.confirm(`Delete ${accountAgent.agent.first_name}?`) === true) {
                    deleteAgent(accountAgent.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  delete
                </Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
        created: accountAgent.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("portal/agents.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaigns(result.data.data.campaigns);
            setAgentGroups(result.data.data.groups);
            const rows = buildRateRows(result.data.data.agents);
            setAgents(rows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function createAgent() {
    if (lastName === null) {
      setSeverity("error");
      setErrMsg("Last name is required.");
      setOpen(true);
      return;
    }

    if (firstName === null) {
      setSeverity("error");
      setErrMsg("First name is required.");
      setOpen(true);
      return;
    }

    if (emailAddress === null) {
      setSeverity("error");
      setErrMsg("Email address is required.");
      setOpen(true);
      return;
    }

    if (phoneNumber === null) {
      setSeverity("error");
      setErrMsg("Phone number is required.");
      setOpen(true);
      return;
    }

    setOpenNewCheckDialog(false);
    setShowLoading(true);
    const json = {
      last_name: `${lastName}`,
      first_name: `${firstName}`,
      email_address: `${emailAddress}`,
      phone_number: `${phoneNumber}`,
      staff_number: `${staffNumber}`,
    };

    await axios
      .post("portal/agents/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg("Agent created!");
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function postData(formData) {
    setShowLoading(true);
    await axios
      .post("portal/agents/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  const uploadAgents = () => {
    if (!uploadFile) {
      return;
    }
    const formData = new FormData();
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadAgentsDialog(false);
    setShowLoading(true);

    postData(formData);
  };

  function fileSelected(e) {
    e.persist();
    const fileTypes = ["xlsx", "xls", "csv"];
    const file = e.target.files[0];
    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.indexOf(extension) > -1;
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only excel and csv files accepted.");
      setOpen(true);
      return;
    }
    setUploadFile(e.target.files[0]);
  }

  async function bulkStatusUpdate(statusUpdate) {
    setOpenMoreActionsDialog(false);
    setShowLoading(true);

    const json = {
      status: statusUpdate,
    };

    await axios
      .post(`portal/agents/bulk/action/status.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function bulkStatusUpdateSelected(statusUpdate) {
    if (selectedAgents.length <= 0) {
      setSeverity("error");
      setErrMsg("No agents selected.");
      setOpen(true);
      return;
    }

    setOpenMoreActionsDialog(false);
    setShowLoading(true);

    const json = {
      status: statusUpdate,
      agents: selectedAgents,
    };

    await axios
      .post(`portal/agents/bulk/action/status/selected.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function bulkDelete() {
    if (window.confirm(`Warning! This action cannot be undone. Proceed?`) === false) {
      return;
    }

    setOpenMoreActionsDialog(false);
    setShowLoading(true);

    await axios
      .get(`portal/agents/bulk/action/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function bulkDeleteSelected() {
    if (selectedAgents.length <= 0) {
      setSeverity("error");
      setErrMsg("No agents selected.");
      setOpen(true);
      return;
    }

    if (window.confirm(`Warning! This action cannot be undone. Proceed?`) === false) {
      return;
    }

    setOpenMoreActionsDialog(false);
    setShowLoading(true);

    const json = {
      agents: selectedAgents,
    };

    await axios
      .post(`portal/agents/bulk/action/delete/selected.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function assignToGroup() {
    if (selectedGroup === null) {
      setSeverity("error");
      setErrMsg("No group selected.");
      setOpen(true);
      return;
    }

    if (selectedAgents.length <= 0) {
      setSeverity("error");
      setErrMsg("No agents selected.");
      setOpen(true);
      return;
    }

    setOpenAssignGroupDialog(false);
    setShowLoading(true);

    const json = {
      group: selectedGroup,
      agents: selectedAgents,
    };

    await axios
      .post(`portal/agents/assign/group.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          // setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function assignToCampaign() {
    if (selectedCampaign === null) {
      setSeverity("error");
      setErrMsg("No campaign selected.");
      setOpen(true);
      return;
    }

    if (selectedAgents.length <= 0) {
      setSeverity("error");
      setErrMsg("No agents selected.");
      setOpen(true);
      return;
    }

    setOpenAssignCampaignDialog(false);
    setShowLoading(true);

    const json = {
      campaign: selectedCampaign,
      agents: selectedAgents,
    };

    await axios
      .post(`portal/agents/assign/campaign.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          // setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MessageDialog
        destinationType={messageDestinationType}
        destinationKey={messageDestinationKey}
        description={messageDestinationDescription}
        displayState={showMessageComponentDialog}
        setDisplayState={setShowMessageComponentDialog}
      />
      <Dialog open={openAssignCampaignDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Assign To Campaign</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={1}>
            <MDBox mb={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Select Campaign</InputLabel>
                <Select
                  label="Select Campaign"
                  onChange={(e) => {
                    setSelectedCampaign(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {campaigns.map((campaign) => (
                    <MenuItem value={campaign.reference}>{campaign.title}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAssignCampaignDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              assignToCampaign();
            }}
          >
            Assign Agents
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAssignGroupDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Assign To Group</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={1}>
            <MDBox mb={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Select Agent Group</InputLabel>
                <Select
                  label="Select Agent Group"
                  onChange={(e) => {
                    setSelectedGroup(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {agentGroups.map((group) => (
                    <MenuItem value={group.reference}>{group.title}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAssignGroupDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              assignToGroup();
            }}
          >
            Assign Agents
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openNewCheckDialog} fullWidth>
        <DialogTitle>
          <MDBox>New Agent</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mb={2}>
              <MDInput
                name="last_name"
                margin="dense"
                label="Last Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setLastName(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                name="first_name"
                margin="dense"
                label="First Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setFirstName(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                name="email_address"
                margin="dense"
                label="Email Address"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setEmailAddress(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                name="phone_number"
                margin="dense"
                label="Phone Number"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                placeholder="Staff ID"
                name="staff_number"
                margin="dense"
                label="Staff Number (Optional)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setStaffNumber(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewCheckDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createAgent();
            }}
          >
            Add Agent
          </MDButton>
        </DialogActions>
      </Dialog>
      {selectedAgent ? (
        <Dialog open={openEditCheckDialog} fullWidth>
          <DialogTitle>
            <MDBox>Edit Agent</MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox sx={{ marginTop: "15px" }}>
              <MDBox mb={2}>
                <MDInput
                  name="last_name"
                  margin="dense"
                  label="Last Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  name="first_name"
                  margin="dense"
                  label="First Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  name="email_address"
                  margin="dense"
                  label="Email Address"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={emailAddress}
                  onChange={(e) => setEmailAddress(e.target.value)}
                />
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  name="phone_number"
                  margin="dense"
                  label="Phone Number"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  placeholder="Staff ID"
                  name="staff_number"
                  margin="dense"
                  label="Staff Number (Optional)"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={staffNumber}
                  onChange={(e) => setStaffNumber(e.target.value)}
                />
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenEditCheckDialog(false);
              }}
              color="dark"
              variant="outlined"
            >
              Cancel
            </MDButton>
            <MDButton
              color="dark"
              variant="contained"
              onClick={() => {
                editAgent();
              }}
            >
              Edit Agent
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}

      <Dialog open={openUploadAgentsDialog}>
        <DialogTitle>
          <MDBox>Upload Agents</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={4}>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                // onChange={handleFileInputChange}
                onChange={(e) => fileSelected(e)}
              />
            </MDBox>
            <MDBox mt={2} pl={3} alignContents="center">
              <a
                href={`${AppConfig.api_media_url}documents/templates/agent_upload_template.csv`}
                target="_blank"
                rel="noreferrer"
              >
                == Sample Template ==
              </a>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadAgentsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              uploadAgents();
            }}
          >
            Upload Agents
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog open={openMoreActionsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Perform Bulk Action</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular">
                Disable only selected agents
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkStatusUpdateSelected(false);
                    }
                  }}
                  color="info"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>pause</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular">
                Disable all agents
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkStatusUpdate(false);
                    }
                  }}
                  color="info"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>pause</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3}>
              <Divider />
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular">
                Enable only selected agents
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkStatusUpdateSelected(true);
                    }
                  }}
                  color="success"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>play_arrow</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular">
                Enable all agents
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkStatusUpdate(true);
                    }
                  }}
                  color="success"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>play_arrow</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3}>
              <Divider />
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular" color="error">
                Delete only selected agents from account
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkDeleteSelected();
                    }
                  }}
                  color="error"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>delete</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular" color="error">
                Delete all agents from account
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkDelete();
                    }
                  }}
                  color="error"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>delete</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenMoreActionsDialog(false);
            }}
            color="dark"
            variant="outlined"
            iconOnly
            circular
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mt={1} pb={3}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={0}>
                  <MDBox align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>people</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                        Manage your teams
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontWeight="light" fontSize={14}>
                        Onboard and manage members of your entire team in one place.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={5} mb={3}>
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setOpenNewCheckDialog(true);
                        }}
                        startIcon={<Icon>add</Icon>}
                      >
                        Add Agent
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            {agents.length > 0 && (
              <MDBox mt={5}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={0}>
                    <MDBox
                      pt={2}
                      px={2}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <MDTypography variant="h6" fontWeight="medium">
                        Agents
                      </MDTypography>
                      <MDBox>
                        <Tooltip title="Add Agent">
                          <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setOpenNewCheckDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          </MDButton>
                        </Tooltip>
                        &nbsp;
                        <Tooltip title="Upload Agents">
                          <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setOpenUploadAgentsDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                          </MDButton>
                        </Tooltip>
                        &nbsp;
                        <Tooltip title="Download Agents">
                          <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              const downloadUrl = `${AppConfig.api_base_url}account/agents/${accountInfo.account.reference}/${accountInfo.user.reference}/export.json`;
                              window.open(downloadUrl, "_blank");
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>download</Icon>
                          </MDButton>
                        </Tooltip>
                        &nbsp;&nbsp;
                        <Tooltip title="Assign To Group">
                          <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setSelectedGroup(null);
                              setOpenAssignGroupDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>group_add</Icon>
                          </MDButton>
                        </Tooltip>
                        &nbsp;
                        <Tooltip title="Assign To Campaign">
                          <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setSelectedCampaign(null);
                              setOpenAssignCampaignDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>person_add_alt</Icon>
                          </MDButton>
                        </Tooltip>
                        &nbsp;&nbsp;
                        <Tooltip title="Message Agents">
                          <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setMessageDestinationType("account.agents");
                              setMessageDestinationKey(accountInfo.account.reference);
                              setMessageDestinationDescription("Send message to all your agents");
                              setShowMessageComponentDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>mail</Icon>
                          </MDButton>
                        </Tooltip>
                        &nbsp;&nbsp;
                        <Tooltip title="Bulk Actions">
                          <MDButton
                            variant="outlined"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setOpenMoreActionsDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>more_vert</Icon>
                          </MDButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                    <MDBox mt={5}>
                      <DataTable
                        table={{ columns: tableColumns, rows: agents }}
                        isSorted
                        entriesPerPage
                        showTotalEntries
                        noEndBorder
                      />
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            )}
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Agents;
